/**
 * Element - button
 */

export const button = ():void => {
  // Run the script for each individual element found on the page
  const elementSelector = document.querySelectorAll('.js-button') as unknown as HTMLElement[]
  elementSelector.forEach((element:HTMLElement) => {
    element.addEventListener('click', createRipple)
  })

  function createRipple (event) {
    const button = event.currentTarget

    const circle = document.createElement('span')

    const btnRect = button.getBoundingClientRect()
    const diameter = Math.max(btnRect.width, btnRect.height)
    const radius = diameter / 2
    circle.style.width = circle.style.height = `${diameter}px`
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    circle.style.left = `${event.clientX - (btnRect.left + radius)}px`
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    circle.style.top = `${event.clientY - (btnRect.top + radius)}px`
    circle.classList.add('ripple')

    const ripple = button.getElementsByClassName('ripple')[0]

    if (ripple) {
      ripple.remove()
    }

    button.appendChild(circle)
  }
}
